<div class="error">
  <h1>{{ errorMessage.title }}</h1>
  <p>{{ errorMessage.message }}</p>
  @if (errorMessage.url) {
    <button class="btn btn-block btn-action" (click)="onErrorButtonClicked()">
      {{ errorMessage.buttonMessage }}
    </button>
  }
</div>
